import {
  Toaster as ToasterStateless,
  type ToasterProps,
  toast,
  useToasts,
  TOASTER_PADDING_OFFSET,
  CONTROL_BAR_HEIGHT,
} from '@doxyme/ui/components';
import { useTheme } from '@doxyme/ui-foundation/theme';
import { useViewport } from '@doxyme/ui-foundation/hooks';
import { useThemeNameByRoute } from '../../../hooks/useThemeNameByRoute';
import { withState } from '../../../shared/withState';
import { useEffect } from 'react';
import { useAppRouter } from '../../../hooks/useAppRouter';
import { getPublicRuntimeConfig } from '../../../libs/init/getPublicRuntimeConfig';
import {
  CALL_TIMER_HEIGHT,
  CALL_TIMER_VERTICAL_PADDING,
} from '../../call/inCallPanel/callTimer/callTimer.constants';

const useToaster = () => {
  const themeName = useThemeNameByRoute();
  const { isLargeViewport, isMediumViewport } = useViewport();
  const theme = useTheme();
  const { toasts } = useToasts();

  const { pathname } = useAppRouter();
  const { paths } = getPublicRuntimeConfig();

  const isInCall = pathname === paths.call;

  // Position the toast stack just above the call controls bar plus extra padding
  const inCallOffset = CONTROL_BAR_HEIGHT + TOASTER_PADDING_OFFSET;

  // Only adjust positioning when actually in a call view
  const offset = !isInCall ? undefined : { bottom: inCallOffset };

  const mobileOffset = {
    bottom: isInCall
      ? inCallOffset + CALL_TIMER_HEIGHT + CALL_TIMER_VERTICAL_PADDING
      : TOASTER_PADDING_OFFSET,
    left: theme.spacing(6),
    right: theme.spacing(6),
  };

  /**
   * We want to hide all toasts on viewport changes.
   * This is because when switching viewports, the toasts are not be positioned correctly
   * Only new toasts created within the new viewport are be positioned correctly.
   */
  useEffect(() => {
    toasts.forEach((t) => toast.dismiss(t.id));
  }, [isLargeViewport, isMediumViewport]);

  return {
    themeName,
    offset,
    mobileOffset,
  };
};

export const Toaster = withState<ToasterProps>(useToaster, ToasterStateless);
